<template>
    <!-- confirm -->
    <div class="profile__setting profile__setting--confirm">
        <dl class="name">
            <dt>{{ $t("LABEL_NAME") }}</dt>
            <dd>
                <p>{{ userStore.isOverseasUser ? userStore.accountUpdateParams.first_name : userStore.accountUpdateParams.last_name + " " + userStore.accountUpdateParams.first_name }}</p>
            </dd>
        </dl>
        <dl v-if="!userStore.isOverseasUser" class="kana">
            <dt>{{ $t("LABEL_NAME_KANA") }}</dt>
            <dd>
                <p>{{ userStore.accountUpdateParams.last_name_kana + " " + userStore.accountUpdateParams.first_name_kana }}</p>
            </dd>
        </dl>
        <dl class="sex">
            <dt>{{ $t("LABEL_GENDER") }}</dt>
            <dd>
                <p>{{ GENDER_LIST[userStore.accountUpdateParams.sex] }}</p>
            </dd>
        </dl>
        <dl class="birth">
            <dt>{{ $t("LABEL_BIRTHDATE") }}</dt>
            <dd>
                <p>{{ userStore.accountUpdateParams.birthday }}</p>
            </dd>
        </dl>
        <dl class="address">
            <dt>{{ $t('LABEL_ADDRESS') }}</dt>
            <dd>
            <p>{{ userStore.accountUpdateParams.zip_code }}</p>
            <p>{{ userStore.accountUpdateParams.address_1_name }} {{ userStore.accountUpdateParams.address_2 }} </p>
            <p>{{ userStore.accountUpdateParams.address_3 }}</p>
        </dd>
        </dl>
            <dl class="telephone">
                <dt>{{ $t('LABEL_PHONE_NUMBER') }}</dt>
            <dd>
                <p>{{ userStore.accountUpdateParams.tel }}</p>
            </dd>
        </dl>
    </div>
</template>
<script setup>
import { useUserStore } from "@/stores/userStore";
import { GENDER_LIST } from "@/data/constants";
const userStore = useUserStore();
</script>